
const ProductionDailyActivityDelete = ({
    activity,
    loading,
    onClose,
    onConfirm
}) => {

    if (!activity) {
        return null;
    }

    return (

        <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{
                backgroundColor: "rgba(0,0,0,0.5)"
            }}
        >

            <div className="modal-dialog modal-dialog-centered">

                <div className="modal-content">


                    {/* HEADER */}

                    <div className="modal-header">

                        <h5 className="modal-title text-danger">
                            Delete Activity
                        </h5>

                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                            disabled={loading}
                        />

                    </div>


                    {/* BODY */}

                    <div className="modal-body">

                        <p>
                            Are you sure you want to delete this
                            production activity?
                        </p>

                        <div className="alert alert-warning">

                            <strong>
                                Activity ID:
                            </strong>{" "}
                            {activity.activity_id ?? "-"}

                            <br />

                            <strong>
                                Remark:
                            </strong>{" "}
                            {activity.remark ?? "-"}

                        </div>

                        <small className="text-muted">
                            This record will be marked as deleted.
                        </small>

                    </div>


                    {/* FOOTER */}

                    <div className="modal-footer">

                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>

                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={onConfirm}
                            disabled={loading}
                        >

                            {loading
                                ? "Deleting..."
                                : "Delete"}

                        </button>

                    </div>

                </div>

            </div>

        </div>
    );
};

export default ProductionDailyActivityDelete;

